import axios from 'axios'
import library from '../../../utils/Library'

export const helpDeleteFileExtends = async (fileExtension) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('fileExtend') + `/delete/${fileExtension}`
  return await axios({
    url: URL,
    method: 'DELETE',
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
